import React from "react"
import {graphql} from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/hero"

import LinkButton from "../components/link-button"

// We are using Material Design Icons
import {
  MdHotel,
  MdPieChart,
  MdLightbulbOutline,
  MdAvTimer,
  MdAirplanemodeActive,
  MdGroup,
  MdMultilineChart
} from "react-icons/md"

// Local components
import BlockContainer from "../components/block/block-container"
import BlockCTA from "../components/block/block-cta"
import BlockGrid from "../components/block/block-grid"
import BlockGridItem from "../components/block/block-grid-item"
import BlockContent from "../components/block/block-content"
import BlockImage from "../components/block/block-image"
import BlockForm from "../components/block/block-form"
import video from "../images/video/077866491-1910s-birth-telephone-operator_H264_420_1.mp4"
import image from "../images/photos/home-background.png"
const config = {
  heroVideoURL: video,
  heroBackgroundImage: null,
  heroH1: "VOICE AND MESSAGING FOR THE PROS",
  heroH2:
    "A communications platform that addresses the unique needs of your customers, from a team who cares.",
  heroCTAText: "Speak with a Voxologist",
  heroCTALink: "/contact-us",
  heroText: "",
  heroCaption: "The Expansion of the Telephone | 1910s"
}

const IndexPage = ({location, data, site}) => {
  return (
    <Layout location={location}>
      <SEO title="Home" />
      <Hero {...config} />

      <BlockContainer theme="">
        <h2>
          Tired of feeling like your communications provider isn’t on your side?
        </h2>
        <BlockGrid>
          <BlockGridItem>
            <MdHotel />
            <p>Apathetic "support" that doesn’t actually support you</p>
          </BlockGridItem>
          <BlockGridItem>
            <MdPieChart />
            <p>
              Losing customers to your competition because your platform isn’t
              flexible or scalable
            </p>
          </BlockGridItem>
          <BlockGridItem>
            <MdLightbulbOutline />
            <p>
              Wasting time maintaining your communications platform rather than
              building your next big idea
            </p>
          </BlockGridItem>
        </BlockGrid>
        <BlockCTA>
          We believe you deserve more.
          <LinkButton
            link="/contact-us"
            text="Speak With A Voxologist"
            target=""
          />
        </BlockCTA>
      </BlockContainer>

      <BlockContainer theme="secondary">
        <h2>
          Build and scale your application with a team that has enabled
          trillions of interactions.
        </h2>

        <BlockContent>
          <BlockImage file={data.callFlow} alt="Call Flow" />
          <ol>
            <li>
              Schedule a call
              <br /> <small>with a Voxologist.</small>
            </li>
            <li>
              Collaborate with our team
              <br />
              <small>
                to craft and execute a successful Integration Plan*.
              </small>
            </li>
            <li>
              Enjoy the power
              <br />
              <small> of communications, without the fuss.</small>
            </li>
          </ol>
        </BlockContent>
        <BlockCTA>
          <LinkButton
            link="/contact-us"
            text="Speak With A Voxologist"
            target=""
          />
        </BlockCTA>
      </BlockContainer>

      <BlockContainer>
        <h2>
          Stop buying communications like an amateur, start investing in your
          communications like a pro.
        </h2>
        <BlockGrid>
          <BlockGridItem>
            <MdAvTimer />
            <p>Reclaim your team's time by minimizing 'communications fuss'</p>
          </BlockGridItem>
          <BlockGridItem>
            <MdAirplanemodeActive />
            <p>Scale your business successfully, with our help</p>
          </BlockGridItem>
          <BlockGridItem>
            <MdGroup />
            <p>Gain peace of mind, knowing that our team is here for you</p>
          </BlockGridItem>
          <BlockGridItem>
            <MdMultilineChart />
            <p>Maximize your margins without sacrificing reliability</p>
          </BlockGridItem>
        </BlockGrid>
        <BlockCTA>
          <p>Have you found your lifelong communications provider?</p>
          <LinkButton
            link="/contact-us"
            text="Speak With A Voxologist"
            target=""
          />
        </BlockCTA>
      </BlockContainer>

      <BlockContainer theme="secondary">
        <h2>About Voxology</h2>
        <h3>A team that believes that communication matters.</h3>
        <BlockContent>
          <p>
            At Voxology, we provide the reliable communications your company
            needs, without the headache. Our team of experts is invested in your
            success so that you can finally feel at ease when it comes to your
            communication strategy.
            <br /> <br />
            How is it even possible that the industry responsible for
            communications is ironically lousy at both communicating with and
            listening to their customers? Here at Voxology, we believe
            communication matters. And, we know that great communication
            requires listening. That’s why we take the time to learn about your
            specific business needs and educate our team, so when you have
            questions, we can truly help instead of offering generic solutions.
            <br /> <br />
            We care about your business and what you are trying to accomplish.
            Whether you are looking to build something simple, or you want to
            create complex and customized call flows, we can help you scale your
            business successfully and minimize frustration.
            <LinkButton
              link="/contact-us"
              text="Speak With A Voxologist"
              target=""
            />
          </p>
          <BlockImage file={data.about} alt="About Us" align="right" />
        </BlockContent>
      </BlockContainer>
    </Layout>
  )
}

export const query = graphql`
  query MyQuery {
    callFlow: file(relativePath: {eq: "home/Call-Flow-Diagram-2.png"}) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 800) {
          aspectRatio
          ...GatsbyImageSharpFluid
        }
      }
    }
    about: file(relativePath: {eq: "home/About_Voxology.png"}) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxWidth: 500) {
          aspectRatio
          ...GatsbyImageSharpFluid
        }
      }
    }
    small: file(relativePath: {eq: "home/fillmurray360x640.jpg"}) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        fluid(maxHeight: 200) {
          aspectRatio
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default IndexPage
